import { render } from "./ResetLayout.vue?vue&type=template&id=3a196286"
const script = {}

import "./ResetLayout.vue?vue&type=style&index=0&id=3a196286&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__